import React, { useCallback } from "react";
import {
  StoreFilesScreenComponent,
  onPressIntegrationFileType,
} from "./FilesScreenComponent";
import { useOpenFile } from "./useOpenFile";
import { FileNavigatorScreenProp } from "./FileStack";

export function FilesScreen({
  navigation,
}: FileNavigatorScreenProp<"FilesMain">) {
  const openFile = useOpenFile();
  const onShowAllFiles = useCallback(() => {
    navigation.navigateDeprecated("AllFiles", { teamId: "" });
  }, [navigation]);
  const onPressIntegrationFile: onPressIntegrationFileType = useCallback(
    ({ id, title }) => {
      navigation.navigateDeprecated("EmaginWebview", { eMaginId: id, title });
    },
    [navigation]
  );

  return (
    <StoreFilesScreenComponent
      modal
      includeIntegrationFiles
      onShowAllFiles={onShowAllFiles}
      onPressFile={openFile}
      onPressIntegrationFile={onPressIntegrationFile}
      setHeaderRight={(p) => {
        navigation.setOptions({
          headerRight: p,
        });
      }}
    />
  );
}
